import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { products } from "../data/mock";
import { ProductImage } from "./ProductImage";

export const FeaturedProducts = () => {
  const navigate = useNavigate();

  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#ff9900] font-semibold text-sm uppercase tracking-wider">
            Our Products
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mt-3 mb-4">
            Featured Solutions
          </h2>
          <p className="text-[#4a6680] max-w-2xl mx-auto text-lg">
            Explore our range of reliable automation products designed for efficiency and durability.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => {
            return (
              <div
                key={product.id}
                className={`group bg-white rounded-2xl border border-[#e2e8f0] overflow-hidden hover:shadow-xl hover:shadow-[#0a2a43]/5 transition-all duration-500 hover:-translate-y-1 ${index >= 3 ? "sm:col-span-1 lg:col-span-1" : ""
                  }`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <ProductImage
                    publicId={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a2a43]/60 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#0a2a43] mb-2 group-hover:text-[#ff9900] transition-colors duration-300">
                    {product.title}
                  </h3>
                  <p className="text-[#4a6680] text-sm leading-relaxed mb-5">
                    {product.shortDescription}
                  </p>
                  <Button
                    onClick={() => navigate("/products")}
                    variant="ghost"
                    className="text-[#ff9900] hover:text-[#e68a00] hover:bg-[#ff9900]/5 font-semibold px-0 group/btn"
                  >
                    More Details
                    <ArrowRight className="w-4 h-4 ml-1 group-hover/btn:translate-x-1 transition-transform duration-200" />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        {/* View All */}
        <div className="text-center mt-14">
          <Button
            onClick={() => navigate("/products")}
            className="bg-[#0a2a43] hover:bg-[#0d3a5c] text-white font-semibold px-8 py-6 text-base rounded-xl shadow-lg shadow-[#0a2a43]/15 hover:shadow-xl transition-all duration-300"
          >
            View All Products
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};
